import { createFileRoute } from '@tanstack/react-router';
import { Legal } from '@/app/legal/Legal.page';

export const Route = createFileRoute('/impressum')({
    component: Legal,
});

